function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import Location from '../../geom/Location';
import EdgeEnd from '../../geomgraph/EdgeEnd';
import Position from '../../geomgraph/Position';
import GeometryGraph from '../../geomgraph/GeometryGraph';
import Label from '../../geomgraph/Label';
import ArrayList from '../../../../../java/util/ArrayList';
import Edge from '../../geomgraph/Edge';
var EdgeEndBundle = /*#__PURE__*/function (_EdgeEnd) {
  function EdgeEndBundle() {
    var _this;
    _classCallCheck(this, EdgeEndBundle);
    _this = _callSuper(this, EdgeEndBundle);
    EdgeEndBundle.constructor_.apply(_this, arguments);
    return _this;
  }
  _inherits(EdgeEndBundle, _EdgeEnd);
  return _createClass(EdgeEndBundle, [{
    key: "insert",
    value: function insert(e) {
      this._edgeEnds.add(e);
    }
  }, {
    key: "print",
    value: function print(out) {
      out.println('EdgeEndBundle--> Label: ' + this._label);
      for (var it = this.iterator(); it.hasNext();) {
        var ee = it.next();
        ee.print(out);
        out.println();
      }
    }
  }, {
    key: "iterator",
    value: function iterator() {
      return this._edgeEnds.iterator();
    }
  }, {
    key: "getEdgeEnds",
    value: function getEdgeEnds() {
      return this._edgeEnds;
    }
  }, {
    key: "computeLabelOn",
    value: function computeLabelOn(geomIndex, boundaryNodeRule) {
      var boundaryCount = 0;
      var foundInterior = false;
      for (var it = this.iterator(); it.hasNext();) {
        var e = it.next();
        var _loc = e.getLabel().getLocation(geomIndex);
        if (_loc === Location.BOUNDARY) boundaryCount++;
        if (_loc === Location.INTERIOR) foundInterior = true;
      }
      var loc = Location.NONE;
      if (foundInterior) loc = Location.INTERIOR;
      if (boundaryCount > 0) {
        loc = GeometryGraph.determineBoundary(boundaryNodeRule, boundaryCount);
      }
      this._label.setLocation(geomIndex, loc);
    }
  }, {
    key: "computeLabelSide",
    value: function computeLabelSide(geomIndex, side) {
      for (var it = this.iterator(); it.hasNext();) {
        var e = it.next();
        if (e.getLabel().isArea()) {
          var loc = e.getLabel().getLocation(geomIndex, side);
          if (loc === Location.INTERIOR) {
            this._label.setLocation(geomIndex, side, Location.INTERIOR);
            return null;
          } else if (loc === Location.EXTERIOR) this._label.setLocation(geomIndex, side, Location.EXTERIOR);
        }
      }
    }
  }, {
    key: "getLabel",
    value: function getLabel() {
      return this._label;
    }
  }, {
    key: "computeLabelSides",
    value: function computeLabelSides(geomIndex) {
      this.computeLabelSide(geomIndex, Position.LEFT);
      this.computeLabelSide(geomIndex, Position.RIGHT);
    }
  }, {
    key: "updateIM",
    value: function updateIM(im) {
      Edge.updateIM(this._label, im);
    }
  }, {
    key: "computeLabel",
    value: function computeLabel(boundaryNodeRule) {
      var isArea = false;
      for (var it = this.iterator(); it.hasNext();) {
        var e = it.next();
        if (e.getLabel().isArea()) isArea = true;
      }
      if (isArea) this._label = new Label(Location.NONE, Location.NONE, Location.NONE);else this._label = new Label(Location.NONE);
      for (var i = 0; i < 2; i++) {
        this.computeLabelOn(i, boundaryNodeRule);
        if (isArea) this.computeLabelSides(i);
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return EdgeEndBundle;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}(EdgeEnd);
export { EdgeEndBundle as default };
EdgeEndBundle.constructor_ = function () {
  this._edgeEnds = new ArrayList();
  if (arguments.length === 1) {
    var e = arguments[0];
    EdgeEndBundle.constructor_.call(this, null, e);
  } else if (arguments.length === 2) {
    var boundaryNodeRule = arguments[0];
    var _e = arguments[1];
    EdgeEnd.constructor_.call(this, _e.getEdge(), _e.getCoordinate(), _e.getDirectedCoordinate(), new Label(_e.getLabel()));
    this.insert(_e);
  }
};